export const removeClasses = (classList: DOMTokenList, classes: string): void =>
  classes && classList?.length > 0 && classList.remove(...classes.split(' '));

export const addClasses = (classList: DOMTokenList, classes: string): void => classList.add(...classes.split(' '));
